import { render } from "./ListInternalTransferOfProducts.vue?vue&type=template&id=0201e2c8&scoped=true"
import script from "./ListInternalTransferOfProducts.vue?vue&type=script&lang=js"
export * from "./ListInternalTransferOfProducts.vue?vue&type=script&lang=js"

import "./ListInternalTransferOfProducts.vue?vue&type=style&index=0&id=0201e2c8&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0201e2c8"]])

export default __exports__